import styled from 'styled-components';
import { ModalPanelStyled } from "../../../../../modules/Cashier/styled/CashierStyled.js";

export const MobileAssetInfoHeaderStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
    max-width: 100%;
    overflow: hidden;

    .col-left {
        font-size: 28px;
    }

    .col-center {
        flex: 1;
        overflow: hidden;

        * {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
`;

export const MobileAssetInfoMenuStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 16px;

    > * {
        border-radius: 16px;
        padding: 8px 12px;
        background: rgba(129, 146, 228, 0.1);
        cursor: default;
        color: var(--color-white-60);

        &.selected {
            background: rgba(129, 146, 228, 0.2);
            color: var(--color-white);
        }
    }
`;

export const MobileAssetInfoContentStyled = styled.div`
    ${ModalPanelStyled} {
        margin: 0 0 24px;
    }
`;
